import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { userAlarmQueryOptions } from './user-alarm.query-options';

/**
 * 사용자 알림 설정 query — `userAlarmQueryOptions` (entity SSOT) 를 React 컨텍스트에 적용.
 */
export function useUserAlarmQuery() {
  const api = useApiAppLegacy();
  return useQuery(userAlarmQueryOptions(api));
}
